import validate from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.0_@vue+compiler-sfc@3.5.21_aws4fetch@1.0.20_db0@0.3.2_eslint@9_gd4xzc7kim7efqofxkqkqwp5gi/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.0_@vue+compiler-sfc@3.5.21_aws4fetch@1.0.20_db0@0.3.2_eslint@9_gd4xzc7kim7efqofxkqkqwp5gi/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-auth": () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/middleware/check-auth.ts")
}